import { Anchor, Button, Card, Col, Container, Row } from "react-bootstrap";
import TowingCar from "../Images/CarImage.jpg";
import HomeImage from "../Images/home.png";
import Avatar from "../Images/avatar.svg";
import RianBotes from "../Images/rianbotes.png";
import { ReactComponent as HitByBallIcon } from "../Images/ManHitByBall.svg";
import PersonalInsuranceImage from "../Images/PersonalInsurance.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase, faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import "./Navbar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./PersonalInsurance.css";
import ReactGA from "react-ga4";
import { Fingerprint, House, ShieldCheck, Water, CarFront, Person, ExclamationOctagon } from "react-bootstrap-icons";



export const PersonalInsurance = () => {

    ReactGA.initialize("G-ECGH6LJ63Y");
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });

    return (
        <>
            <Container
                fluid
                style={{
                    background: 'linear-gradient(135deg, #1e1e3f 0%, #3a275e 50%, #ffcc00 100%)',
                    color: '#ffffff',
                    padding: '4rem 2rem',
                    position: 'relative',
                    textAlign: 'center',
                    overflow: 'hidden',
                }}
            >
                {/* Optional Overlay for a polished effect */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                        zIndex: 1,
                    }}
                />

                {/* Header Content */}
                <div style={{ position: 'relative', zIndex: 2 }}>
                    <h1 style={{ fontSize: '3rem', fontWeight: '700', marginBottom: '1rem' }}>
                        Personal Insurance
                    </h1>
                    <p style={{ fontSize: '1.25rem', maxWidth: '700px', margin: '0 auto', color: '#f0f0f0' }}>
                        Secure your lifestyle and assets with reliable, flexible personal insurance solutions tailored to you.
                    </p>
                </div>
            </Container>
            <br />
            <Container>
                <Row
                    style={{
                        backgroundColor: '#ffffff',
                        padding: '2.5rem',
                        borderRadius: '20px',
                        boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.1)',
                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0px 6px 24px rgba(0, 0, 0, 0.1)';
                    }}
                    className="align-items-start mb-5"
                >
                    {/* Grid */}
                    <Col lg={8}>
                        <h3
                            style={{
                                fontSize: '1.5rem',
                                color: '#343a40', // A softer dark tone than #1e1e3f
                                fontWeight: '600',
                                marginBottom: '1.5rem',
                                letterSpacing: '0.5px',
                                textAlign: 'center'
                            }}
                        >
                            We Specialize In
                        </h3>
                        <Row>
                            {[
                                { icon: <House />, label: 'House Owners' },
                                { icon: <CarFront />, label: 'Car Insurance' },
                                { icon: <Water />, label: 'Watercraft' },
                                { icon: <ShieldCheck />, label: 'Extended Personal Liability' },
                                { icon: <Fingerprint />, label: 'Identity Theft & Cyber Risk' },
                                { icon: <ExclamationOctagon />, label: "Unexpected Events ..." }
                            ].map((item, idx) => (
                                <Col md={6} lg={4} className="text-center mb-4" key={idx}>
                                    <div
                                        style={{
                                            backgroundColor: '#f8f9fa', // Light grey background
                                            borderRadius: '8px',
                                            padding: '1rem',
                                            color: '#1e1e3f',
                                            boxShadow: 'none', // Remove button-like shadow
                                            border: '1px solid #e0e0e0', // Optional light border
                                        }}
                                    >
                                        <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>{item.icon}</div>
                                        <p style={{ fontWeight: '500', margin: 0 }}>{item.label}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Col>

                    {/* Broker Contact Card */}
                    <Col lg={4} className="mt-4 mt-lg-0">
                        <Card
                            style={{
                                borderRadius: '15px',
                                boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.15)',
                                padding: '2rem',
                                textAlign: 'center',
                            }}
                        >
                            <Card.Body>
                                <div
                                    style={{
                                        width: '100px',
                                        height: '100px',
                                        borderRadius: '50%',
                                        overflow: 'hidden',
                                        margin: '0 auto',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    <img
                                        src={RianBotes}
                                        alt="Broker"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </div>
                                <h3 style={{ fontSize: '1.5rem', margin: '1rem 0 0.5rem 0', fontWeight: '600' }}>Rian Botes</h3>
                                <p style={{ fontSize: '1rem', color: '#555' }}>Your personal guide for insurance solutions.</p>
                                <p style={{ fontSize: '1rem', color: '#007BFF' }}>
                                    <FontAwesomeIcon icon={faPhone} /> 082 880 4219 <br />
                                    <FontAwesomeIcon icon={faEnvelope} /> info@logosbrokers.co.za
                                </p>
                                <Button
                                    variant="primary"
                                    href="https://wa.me/828804219"
                                    style={{ marginTop: '1rem' }}
                                >
                                    Message on WhatsApp
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <br />
            <Container>
                {/* Car Insurance Section */}
                <Row
                    style={{
                        backgroundColor: '#ffffff',
                        padding: '2.5rem',
                        borderRadius: '20px',
                        boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.1)',
                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0px 6px 24px rgba(0, 0, 0, 0.1)';
                    }}
                    className="align-items-center mb-5"
                >
                    <Col xs={12} md={6} className="text-center mb-4 mb-md-0">
                        <img
                            src={TowingCar}
                            alt="Car Insurance"
                            style={{
                                width: '100%',
                                height: 'auto',
                                maxWidth: '500px', // Optionally limit the max width for larger screens
                            }}
                        />
                    </Col>
                    <Col xs={12} md={6}>
                        <h2 style={{ fontSize: '2rem', color: '#1e1e3f' }}>Car Insurance</h2>
                        <p style={{ fontSize: '1.1rem', color: '#333' }}>
                            Your car isn’t just a vehicle; it’s part of your life. Our car insurance policies provide comprehensive coverage to keep you moving, no matter what comes your way.
                            With options for full coverage, third-party insurance, and flexible deductibles, we’ve got your journey covered.
                        </p>
                    </Col>
                </Row>


                {/* Home Insurance Section */}
                <Row style={{
                    backgroundColor: '#ffffff',
                    padding: '2.5rem',
                    borderRadius: '20px',
                    boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.1)',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0px 6px 24px rgba(0, 0, 0, 0.1)';
                    }} className="align-items-center mb-5" >
                    <Col md={6}>
                        <h2 style={{ fontSize: '2rem', color: '#1e1e3f' }}>Home Insurance & All Risk</h2>
                        <p style={{ fontSize: '1.1rem', color: '#333' }}>
                            Your home is your sanctuary. Our home insurance policies protect your property and belongings, giving you peace of mind against fire, theft, and natural disasters.
                            Customize your coverage to suit your home and valuables, ensuring you’re always protected where it matters most.
                        </p>
                    </Col>
                    <Col xs={12} md={6} className="text-center mb-4 mb-md-0">
                        <img
                            src={HomeImage}
                            alt="Car Insurance"
                            style={{
                                width: '100%',
                                height: 'auto',
                                maxWidth: '500px', // Optionally limit the max width for larger screens
                            }}
                        />
                    </Col>
                </Row>

                {/* Additional Services Container */}



            </Container>
            <br />
        </>
    );
}